/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum profil_type_lvls {
  GLOBAL = 'Global',
  DEFENSIVE = 'Defensive',
  OFFENSIVE = 'Offensive',
  ARMY = 'Army',
}
